import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";
import CurriculumExplorer from "@/pages/CurriculumExplorer";
import CurriculumDetail from "@/pages/CurriculumDetail";
import Careers from "@/pages/Careers";
import Communities from "@/pages/Communities";
import Tutors from "@/pages/Tutors";
import Mentors from "@/pages/Mentors";
import Assistant from "@/pages/Assistant";
import Dashboard from "@/pages/Dashboard";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Marketplace from "@/pages/Marketplace";
import Activities from "@/pages/Activities";
import Impact from "@/pages/Impact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Feedback from "@/pages/Feedback";
import Survey from "@/pages/Survey";
import AdminSurvey from "@/pages/AdminSurvey";
import ParentReadiness from "@/pages/ParentReadiness";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/report/:id" element={<Report />} />
            <Route path="/curriculum" element={<CurriculumExplorer />} />
            <Route path="/curriculum/:id" element={<CurriculumDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/communities" element={<Communities />} />
            <Route path="/tutors" element={<Tutors />} />
            <Route path="/mentors" element={<Mentors />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/admin/survey" element={<AdminSurvey />} />
            <Route path="/parent-readiness" element={<ParentReadiness />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
